<div
  class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-gap-medium gw-overflow-hidden"
>
  <div
    class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-gap-medium gw-overflow-y-auto"
  >
    <div class="gw-flex gw-flex-col gw-gap-2x-small">
      <div class="gw-flex gw-flex-col">
        <span class="gw-text-text-secondary gw-text-base gw-font-normal">
          {{ 'features.withdrawals.modalBankSlip.payingTo' | translate }}
        </span>
        <span
          class="gw-text-text-primary gw-text-base gw-font-extrabold gw-mt-2 gw-mb-small"
        >
          {{
            validated?.finalBeneficiary?.name ||
              validated?.issuingEntity?.name ||
              ('features.withdrawals.modalBankSlip.unknownBeneficiary'
                | translate)
          }}
        </span>
      </div>

      <span
        class="gw-text-text-secondary gw-text-base gw-mb-small gw-font-medium"
      >
        {{ 'features.withdrawals.modalBankSlip.details' | translate }}
      </span>

      <div class="gw-flex gw-flex-col gw-gap-small">
        <div
          class="gw-flex gw-items-center gw-justify-between"
          *ngIf="validated?.finalBeneficiary?.taxID"
        >
          <span class="gw-text-text-primary gw-font-bold">
            {{ 'features.withdrawals.modalBankSlip.cpfCnpj' | translate }}
          </span>
          <span class="gw-text-text-secondary gw-font-normal">
            {{ validated?.finalBeneficiary?.taxID | document }}
          </span>
        </div>

        <div
          class="gw-flex gw-items-center gw-justify-between"
          *ngIf="validated?.issuingEntity?.name"
        >
          <span class="gw-text-text-primary gw-font-bold">
            {{ 'features.withdrawals.modalBankSlip.issuer' | translate }}
          </span>
          <span
            class="gw-max-w-[60%] gw-truncate gw-text-right gw-text-text-secondary gw-font-normal"
          >
            {{ validated?.issuingEntity?.name }}
          </span>
        </div>

        <div
          class="gw-flex gw-items-center gw-justify-between"
          *ngIf="validated?.expiresDate"
        >
          <span class="gw-text-text-primary gw-font-bold">
            {{ 'features.withdrawals.modalBankSlip.dueDate' | translate }}
          </span>
          <span class="gw-text-text-secondary gw-font-normal">
            {{ validated?.expiresDate | date : 'dd/MM/yyyy' : '' : 'pt-BR' }}
          </span>
        </div>

        <div class="gw-flex gw-items-center gw-justify-between">
          <span class="gw-text-text-primary gw-font-bold">
            {{ 'features.withdrawals.modalBankSlip.boletoAmount' | translate }}
          </span>
          <span class="gw-text-text-secondary gw-font-normal">
            {{
              validated?.amount
                | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
            }}
          </span>
        </div>

        <div
          class="gw-flex gw-items-start gw-justify-between gw-gap-small"
          *ngIf="description?.trim()"
        >
          <span class="gw-text-text-primary gw-font-bold gw-shrink-0">
            {{
              'features.withdrawals.modalBankSlip.descriptionLabel' | translate
            }}
          </span>
          <span
            class="gw-max-w-[60%] gw-whitespace-pre-wrap gw-break-words gw-text-right gw-text-text-secondary gw-font-normal"
          >
            {{ description.trim() }}
          </span>
        </div>

        <div
          class="gw-flex gw-items-start gw-justify-between gw-gap-small"
          *ngIf="validated?.digitableLine"
        >
          <span class="gw-text-text-primary gw-font-bold gw-shrink-0">
            {{
              'features.withdrawals.modalBankSlip.digitableLabel' | translate
            }}
          </span>
          <span
            class="gw-max-w-[60%] gw-break-all gw-text-right gw-text-text-secondary gw-font-normal gw-tabular-nums"
          >
            {{ validated?.digitableLine }}
          </span>
        </div>
      </div>
    </div>

    <div
      *ngIf="amountBreakdown"
      class="gw-rounded-xl gw-bg-background-elevation-2 gw-p-medium"
    >
      <gatewee-amount-fee-breakdown
        class="gw-w-full"
        [amount]="amountBreakdown.amount"
        [calculatedFee]="amountBreakdown.calculatedFee"
        [finalAmount]="amountBreakdown.finalAmount"
        inputMode="addFees"
        variant="compact"
      ></gatewee-amount-fee-breakdown>
    </div>

    <div
      *ngIf="insufficientBalance"
      class="gw-rounded-lg gw-border gw-border-status-negative gw-bg-status-negative-pale gw-p-medium gw-text-text-negative gw-text-sm"
      role="alert"
    >
      {{ 'features.withdrawals.modalBankSlip.insufficientBalance' | translate }}
    </div>
  </div>
</div>
